import { PeriodUnitEnum } from '../../types';

const getPeriodInHours = (period: number, unit: PeriodUnitEnum) => {
  let periodInHours = 0;

  switch (unit) {
    case PeriodUnitEnum.HOURS:
      periodInHours = period;
      break;
    case PeriodUnitEnum.DAYS:
      periodInHours = period * 24;
      break;
    default:
      break;
  }

  return periodInHours;
};

export default getPeriodInHours;
